module.exports = __webpack_public_path__ + "static/media/plus_square.e92d418b.svg";